export default __webpack_public_path__ + "static/media/img10.2f07e237.png";